import { render, staticRenderFns } from "./treatment_params_config.vue?vue&type=template&id=55593336&scoped=true"
import script from "./treatment_params_config.vue?vue&type=script&lang=js"
export * from "./treatment_params_config.vue?vue&type=script&lang=js"
import style0 from "./treatment_params_config.vue?vue&type=style&index=0&id=55593336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55593336",
  null
  
)

export default component.exports